import { IndividualProfileService } from "@/api/services/masterService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for Individual
interface Individual {
    id: string;
    name: string;
    nameAsperPan?:string;
    dob: string;
    country: string;
    gender: string;
    address1: string;
    address2: string;
    state: string;
    city: string;
    pinCode: string;
    phone: string;
    mobile: string;
    email: string;
    residentStatus: string;
    professionId: string;
    gstin: string;
    tds: boolean;
    hni: boolean;
    risk: string;
    bankName: string;
    accountNumber: string;
    sourceOfFund: string;
    modeOfPayment: string;
    socialAndFinancialStatus: string;
    remark: string;
    lastReviewDate: string;
    idTypes: IdTypesInterface[];
}
interface IdTypesInterface {
    id: string;
    idName: string;
    idNumber: string;
   
}
interface FormattedCustomer {
    id: string;
    name: string;
    nameAsperPan?:string;
    dob: string;
    country: string;
    gender: string;
    address1: string;
    address2: string;
    state: string;
    city: string;
    pinCode: string;
    phone: string;
    mobile: string;
    email: string;
    residentStatus: string;
    professionId: string;
    gstin: string;
    tds: boolean;
    hni: boolean;
    risk: string;
    bankName: string;
    accountNumber: string;
    sourceOfFund: string;
    modeOfPayment: string;
    socialAndFinancialStatus: string;
    remark: string;
    lastReviewDate: string;
    idTypes: IdTypesInterface;
}

// Define state type
interface IndividualMasterState {
  loading: boolean;
  IndividualList: Individual[];
  FormattedCustomer: FormattedCustomer[];
  error?: string;
}

// Initial state with type safety
const initialState: IndividualMasterState = {
  loading: false,
  IndividualList: [],
  FormattedCustomer: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchIndividualMaster = createAsyncThunk<
  Individual[], 
  void, 
  { rejectValue: string }
>(
  "Individual/fetchIndividualMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await IndividualProfileService.getall()
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch Individual data");
    }
  }
);

// Create slice with strong typing
const IndividualMasterSlice = createSlice({
  name: "IndividualMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndividualMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchIndividualMaster.fulfilled, (state, action: PayloadAction<Individual[]>) => {
        state.IndividualList = action.payload;
        state.FormattedCustomer = action.payload.flatMap(item =>
          item.idTypes?.map(idItem => ({
            ...item,
            idTypes: idItem
          }))
        );
        state.loading = false;
      })
      .addCase(fetchIndividualMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default IndividualMasterSlice.reducer;
